import { Navigate, useLocation, useParams } from "react-router-dom";

export default function UsersLegacyRedirect() {
  const { userID } = useParams();
  const { search, hash } = useLocation(); // zachowaj ?query i #hash
  return <Navigate to={`/users/${userID}${search}${hash}`} replace />;
}